import { render, staticRenderFns } from "./coverBottom.vue?vue&type=template&id=42541af7&scoped=true&"
import script from "./coverBottom.vue?vue&type=script&lang=js&"
export * from "./coverBottom.vue?vue&type=script&lang=js&"
import style0 from "./coverBottom.vue?vue&type=style&index=0&id=42541af7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42541af7",
  null
  
)

export default component.exports